/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from 'react-toolbox/lib/button';
import { vendorDisplayName } from '../../../../../../../../utils';
import Card from 'components/Card';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import ChecklistRescheduler from './checklistRescheduler';
import S from '../styles.scss';

const ChecklistIntro = (props) => {
  const { user, isInbound, answered, canTalk, newDate, newDateNote, newDateError,
          handleIntroQuestion, handleNewDate, handleNewDateNote, submitNewDate, errors,
          phase: { customer_name: customerName, source,
                   workroom: { name: workroom = '' } = {} } = {} } = props;
  const vendor = vendorDisplayName(source, workroom);

  let canTalkGreeting;
  if (isInbound) {
    canTalkGreeting = (<Fragment>
      <p>
        I{'\''}d like to review some information with you as we schedule your installation, do you have a few minutes?
      </p>
      <br />
      <p>
        The number you just called is the best number to reach us. You can also visit our website, serviceprosig.com and chat with us online.
      </p>
    </Fragment>);
  } else if (source === 'IFI') {
    canTalkGreeting = (<Fragment>
      <p>
        Great! I{'\''}d like to go over some information before we add the appointment.
      </p>
      <br />
      <p>
        First, I want to make sure you know the best ways to contact us. We can be reached by phone; would you like a moment to write this down?
        Our number is 833-377-2712.
      </p>
    </Fragment>);
  } else {
    canTalkGreeting = (<Fragment>
      <p>
        Great! I{'\''}d like to go over some information before we start, do you have a few minutes?
      </p>
      <br />
      <p>
        First, I want to make sure you know the best ways to contact us. We can be reached by phone or online. Would you like a moment to write this down?
        Our number is 866-774-4411 or you can chat with us on our website at serviceprosig.com.
      </p>
    </Fragment>);
  }

  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>Scheduling Checklist Intro</h4>
    </div>
    <div className={S.checklistContainer}>
      <p className={S.checklistUserNote}>USER NOTE: Is this an inbound or outbound call?</p>
      <br />
      <Button
        label="INBOUND"
        flat inverse ripple
        disabled={isInbound}
        className={S.standardButton}
        onClick={() => handleIntroQuestion('isInbound', true)}
      />
      <Button
        label="OUTBOUND"
        flat inverse ripple
        disabled={isInbound === false}
        className={S.standardButton}
        onClick={() => handleIntroQuestion('isInbound', false)}
      />
    </div>
    {isInbound === false && <ContainerDiv>
      <DropdownDiv condition={isInbound === false}>
        <div className={S.checklistContainer}>
          <p className={S.checklistUserNote}>USER NOTE: Did the customer answer?</p>
          <br />
          <Button
            label="YES"
            flat inverse ripple
            disabled={answered}
            className={S.standardButton}
            onClick={() => handleIntroQuestion('answered', true)}
          />
          <Button
            label="NO"
            flat inverse ripple
            disabled={answered === false}
            className={S.standardButton}
            onClick={() => handleIntroQuestion('answered', false)}
          />
        </div>
      </DropdownDiv>
    </ContainerDiv>}
    {isInbound === false && answered && <ContainerDiv>
      <DropdownDiv condition={isInbound === false && answered}>
        <div className={S.checklistContainer}>
          {source === 'IFI' ? (<p>
            Good Morning/Afternoon <span className={S.checklistText}>{customerName}</span>. My name is <span className={S.checklistText}>{user}</span>,
            and I{'\''}m calling from Integrity First Installation, your door/window installer for Lowe{'\''}s. Is this a good time to schedule your installation?
          </p>) : (<p>
            Good Morning/Afternoon <span className={S.checklistText}>{customerName}</span>. My name is <span className={S.checklistText}>{user}</span>,
            and I{'\''}m calling from Service Pros, your {vendor} flooring installer. Is this a good time to talk about scheduling your installation?
          </p>)}
          <br />
          <Button
            label="YES"
            flat inverse ripple
            disabled={canTalk}
            className={S.standardButton}
            onClick={() => handleIntroQuestion('canTalk', true)}
          />
          <Button
            label="NO"
            flat inverse ripple
            disabled={canTalk === false}
            className={S.standardButton}
            onClick={() => handleIntroQuestion('canTalk', false)}
          />
        </div>
      </DropdownDiv>
    </ContainerDiv>}
    {canTalk && <ContainerDiv>
      <DropdownDiv condition={canTalk}>
        <div className={S.checklistContainer}>
          {canTalkGreeting}
          <br />
          {vendor === 'Lowe\'s' && source !== 'IFI' && <Fragment>
            <p>
              Also, after your installation is complete, Lowe{'\''}s will reach out via email to survey your experience.
              They will ask about our craftsmanship, our professionalism, and your likelihood to recommend to family and friends. We strive for  10s, as they are the only passing score.
              If at any time during your installation process you do not feel we are earning 10s, please reach out so we can continue to improve our services.
            </p>
            <br />
          </Fragment>}
          <p>
            Do you have any questions so far? Alright, let{'\''}s get you scheduled.
          </p>
        </div>
      </DropdownDiv>
    </ContainerDiv>}
    {!canTalk && answered === false && <ContainerDiv>
      <DropdownDiv condition={!canTalk && answered === false}>
        <div className={S.checklistContainer}>
          <br />
          <Button
            label="Send Scheduling Reminder To Customer"
            flat inverse ripple
            disabled={false}
            className={S.saveButton}
            onClick={() => submitNewDate(false)}
          />
        </div>
      </DropdownDiv>
    </ContainerDiv>}
    <ChecklistRescheduler
      condition={canTalk === false}
      text="When would be a good time to call you back?"
      newDate={newDate}
      handleNewDate={handleNewDate}
      errors={errors}
      newDateNote={newDateNote}
      handleNewDateNote={handleNewDateNote}
      submitNewDate={submitNewDate}
      newDateError={newDateError}
    />
  </Card>);
};

ChecklistIntro.propTypes = {
  user: PropTypes.string,
  phase: PropTypes.object,
  isInbound: PropTypes.bool,
  answered: PropTypes.bool,
  canTalk: PropTypes.bool,
  newDate: PropTypes.string,
  newDateNote: PropTypes.string,
  newDateError: PropTypes.string,
  handleIntroQuestion: PropTypes.func,
  handleNewDate: PropTypes.func,
  handleNewDateNote: PropTypes.func,
  submitNewDate: PropTypes.func,
  errors: PropTypes.object,
};

export default ChecklistIntro;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistIntro.jsx